import state from '../../../store/state';

export default {
  user: {},
  token: null,
  messages: state.messages,
}



// WEBPACK FOOTER //
// ./src/app/auth/vuex/state.js